import { h, render } from 'preact';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { logOutUser } from '../store/actioncreators';
const Nav = ({ username, logOut, user, className }) => h("nav", { className: className },
    h("div", { className: "welcome" },
        "Welcome, ",
        h(NavLink, { to: "/myaccount" }, username)),
    h("ul", null,
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/", exact: true }, "Home")),
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/add/invoice" }, "Add New Invoice")),
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/add/proposal" }, "Add New Proposal")),
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/customers" }, "Customers")),
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/add/customer" }, "Add New Customer")),
        user.role === "admin" ? (h("li", null,
            h(NavLink, { className: "nav__link", to: "/users" }, "Users"))) : null,
        user.role === "admin" ? (h("li", null,
            h(NavLink, { className: "nav__link", to: "/add/user" }, "Add New User"))) : null,
        h("li", null,
            h(NavLink, { className: "nav__link", to: "/myaccount" }, "My Account")),
        h("li", null,
            h("button", { className: "log-out-btn", onClick: logOut }, "Log out"))));
const mapDispatchToProps = dispatch => ({
    logOut() {
        dispatch(logOutUser());
    }
});
export default connect(null, mapDispatchToProps)(Nav);
